import { Dialog, DialogTitle, Stack } from "@mui/material";
import { isValidElement } from "react";
import { create } from "zustand";
import { ButtonClose } from "../components/buttons/button-close";

export const useAppDialog = create((set, get) => ({
  open: false,
  content: '',
  args: {},
  setOpen: open => set({ open }),
  closeDialog: () => set({ open: false }),
  setContent: content => set({ content }),
  invokeDialog: (content, args = {}) => {
    if (!isValidElement(content) && (typeof content === 'function')) {
      return new Promise((resolve, reject) => {
        const close = args?.close;
        args.close = () => {
          reject();
          close && close();
        }
        set({ content: content(resolve, reject, get().closeDialog), args, open: true });
      });
    }
    return set({ content, args, open: true });
  },
}));

useAppDialog.STD = "standard";
useAppDialog.WARN = "warning";

export const AppDialog = () => {
  const {content, open, args, setOpen} = useAppDialog();
  
  const onClose = () => {
    setOpen(false);
    args?.close && args?.close();
  }
  
  return (
    <Dialog
      variant={args.type || useAppDialog.STD}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '100%',
          maxWidth: '540px'
        }
      }}
    >
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        flexWrap={'wrap'}
        pr={1}
      >
        {args?.title && <DialogTitle sx={{ pl: (theme) => theme.spacing(2), flex: 1, lineHeight: 1 }}>{args.title}</DialogTitle>}
        <ButtonClose style={{ flexShrink: 0 }} onClick={onClose} />
      </Stack>
      {content}
    </Dialog>
  )
}